// @flow
import React from 'react';
import { connect } from 'react-redux';

import { FormattedMessage } from 'translations';
import CheckboxField from 'mz-ui-kit/form/CheckboxField';
import config from 'config';

import { isSRPMapShowed, isHourlyRideSearch } from 'app/sagas/selectors';
import { toggleSrpMap } from 'app/actions/srp-map';

const messages = {
  showMap: { id: 'SEARCH_RESULTS.MAP.SHOW_MAP' }
};

type Props = {
  toggleSrpMap: () => void,
  showMap: boolean,
  isHourlyRideSearch: boolean
};

/**
 * 
 * @param {Function} toggleSrpMap 
 * @param {boolean} showMap
 * @return Component
 * 
 * Toggle Map on Search Results
 */
function ShowMap ({ toggleSrpMap, showMap, isHourlyRideSearch }: Props) {
  if (!config.SHOW_SRP_MAP) return null;

  return (
    !isHourlyRideSearch &&
    <CheckboxField
      input={{
        onChange: toggleSrpMap,
        value: showMap
      }}
      appearance="primary-inverse"
      label={<FormattedMessage {...messages.showMap} />}
    />
  );
}

const mapStateToProps = state => ({
  showMap: isSRPMapShowed(state),
  isHourlyRideSearch: isHourlyRideSearch(state)
});

const mapDispatchToProps = {
  toggleSrpMap
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowMap);
